module.exports = __webpack_public_path__ + "img/caret-right.ffb19440.svg";